import React from 'react';
import { Button, HStack, Progress, Spinner, Text } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon, CheckIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../../hooks/isMobile';
import { useIsTablet } from '../../../hooks/isTablet';

interface ContentNavigationProps {
  isBackDisabled: boolean;
  currentSectionCounter: number;
  totalSections: number;
  isNextDisabled: boolean;
  isChalkupsLoading: boolean;
  isChalkedUp: boolean;
  toggleComplete: (value: boolean) => void;
  goToTop: () => void;
  next: () => void;
  back: () => void;
  onHoverNext?: () => void;
  onHoverBack?: () => void;
  uncompletable?: boolean;
  isUsingMaxWidth?: boolean;
  secondRow?: boolean;
}

const ContentNavigation: React.FC<ContentNavigationProps> = (props) => {
  const {
    isBackDisabled,
    currentSectionCounter,
    totalSections,
    isNextDisabled,
    isChalkedUp,
    isChalkupsLoading,
    goToTop,
    toggleComplete,
    next,
    back,
    onHoverBack,
    onHoverNext,
    uncompletable,
    // isUsingMaxWidth,
    secondRow,
  } = props;
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const navButtonStyle = {
    size: isMobile || isTablet ? 'sm' : 'md',
    fontSize: isMobile || isTablet ? '10px' : '18px',
    padding: isMobile || isTablet ? '5px' : '20px',
  };

  return (
    <HStack
      justifyContent="space-between"
      py={secondRow ? 8 : 2}
      pb={8}
      // maxWidth={isUsingMaxWidth ? '1200px' : undefined}
    >
      <Button
        colorScheme="blue"
        disabled={isBackDisabled}
        onClick={() => back()}
        onMouseEnter={() => {
          if (onHoverBack) {
            onHoverBack();
          }
        }}
        leftIcon={<ArrowBackIcon />}
        {...navButtonStyle}
      >
        {window.innerWidth < 399.99 ? '' : t('contentNavigation.previous')}
      </Button>
      <Progress
        value={(currentSectionCounter / totalSections) * 100}
        colorScheme="green"
        borderRadius="8px"
        flexBasis="50%"
        maxW="45%"
        position="relative"
        size={isMobile || isTablet ? 'sm' : 'lg'}
        h={6}
        // backgroundColor="#c7c7c7"
      >
        <Text
          as="span"
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          textAlign="center"
          color="black"
        >
          {currentSectionCounter} / {totalSections}
        </Text>
      </Progress>
      {isNextDisabled && !uncompletable ? (
        isChalkupsLoading ? (
          <Spinner />
        ) : (
          <Button
            colorScheme="green"
            variant={isChalkedUp ? 'solid' : 'outline'}
            onClick={() => {
              toggleComplete(true);
              goToTop();
            }}
            rightIcon={<CheckIcon />}
            {...navButtonStyle}
          >
            {isChalkedUp
              ? t('contentNavigation.contentCompleted')
              : t('contentNavigation.markAsComplete')}
          </Button>
        )
      ) : (
        <Button
          colorScheme="blue"
          disabled={isNextDisabled}
          onClick={() => next()}
          onMouseEnter={() => {
            if (onHoverNext) {
              onHoverNext();
            }
          }}
          {...navButtonStyle}
        >
          <Text mr={2} mb="unset">
            {window.innerWidth < 399.99 ? '' : t('contentNavigation.next')}
          </Text>
          <ArrowForwardIcon />
        </Button>
      )}
    </HStack>
  );
};

export default ContentNavigation;
